import axios from 'axios'

export const axiosClient = axios.create({
    withXSRFToken: false,
})

export function getCsrfFromInput() {
    return document.querySelector<HTMLInputElement>('input[name="_csrf"]')?.value
}
